import {
    ClusterOutlined,
    FieldTimeOutlined,
    TableOutlined,
    UserOutlined,
    SettingOutlined,
    EyeOutlined,
    HeartOutlined,
    DribbbleOutlined,
    DesktopOutlined,
    PlayCircleOutlined,
    GlobalOutlined,
    WifiOutlined,
    LogoutOutlined,
    FileProtectOutlined
}
    from "@ant-design/icons";
import T_Error from "../Views/404"
export const logout = [
    {
        key: 'logout',
        title: "Log Out",
        path: "/logout",
        exact: true,
        icon: <LogoutOutlined />
    }
]
/*
HOW TO USE?
1. under 'root', create a distinct key for upper levels, 
preferrable smaller digit
2. under 'subroot', create
*/
const
    key_profile = 0,
    key_channelsetting = 1,
    key_viewer = 2,
    key_monitor = 3,
    key_online = 4,
    key_timeline = 5,
    key_schedule = 6,
    key_officialschedule = 7,
    key_tvch = 8,
    key_mgmt = 9,
    key_ex = 10


export const root = [
    //declare the first layer here
    //if the menu itself is a function, do not assign 
    // sub/childs in, and apply path, Do not apply path if otherwise
    {
        key: key_profile,
        permission: [],
        title: "Profile",
        path: "/profile",
        exact: true,
        icon: <UserOutlined />,
    },

    {
        key: key_channelsetting,
        permission: [],
        title: "User/Channel Setting",
        exact: true,
        icon: <SettingOutlined />,
    },
    {
        key: key_viewer,
        permission: [],
        title: "Viewer",
        exact: true,
        icon: <EyeOutlined />
    },
    {
        key: key_monitor,
        permission: [],
        title: "Monitor",
        path: "/controller",
        exact: true,
        icon: <DesktopOutlined />
    },
    {
        key: key_online,
        permission: [],
        title: "Online",
        exact: true,
        icon: <WifiOutlined />
    },
    {
        key: key_timeline,
        permission: [],
        title: "Timeline",
        path: "/timeline",
        exact: true,
        icon: <FieldTimeOutlined />,
    },
    {
        key: key_schedule,
        permission: [],
        title: "Schedule",
        path: "/schedule",
        exact: true,
        icon: <TableOutlined />,
    },
    {
        key: key_officialschedule,
        permission: [],
        title: "Official Schedule",
        exact: true,
        icon: <TableOutlined />,
    },
    {
        key: key_tvch,
        permission: [],
        title: "TV Chnl-Prog",
        path: "/tvschedules",
        exact: true,
        icon: <DesktopOutlined />
    },
    {
        key: key_mgmt,
        permission: [],
        title: "Management",
        exact: true,
        icon: <ClusterOutlined />,
        render: <T_Error />
    }
];
export const subroot = [
    //#region user/channel setting -- key = 
    // key_profile
    {
        key: '1-1',
        title: 'Channel Setting',
        path: "/channel",
        parent: key_channelsetting,
        exact: true,
        icon: <SettingOutlined />
    },
    //#endregion user/channel setting
    {
        key: '1-1===',
        title: 'under extra Setting',
        path: "/channel",
        parent: key_ex,
        exact: true,
        icon: <SettingOutlined />
    },
    //#region viewer -- key =key_viewer
    {
        key: '2-1',
        title: 'Basic Viewer',
        path: "/viewer",
        parent: key_viewer,
        exact: true,
        icon: <EyeOutlined />
    },
    {
        key: '2.2',
        title: 'Horse RTMP Viewer',
        path: "/viewerhr",
        exact: true,
        parent: key_viewer,
        icon: <EyeOutlined />
    },
    {
        key: '2.3',
        title: 'Horse H5 Viewer',
        path: "/viewerhrh5",
        exact: true,
        parent: key_viewer,
        icon: <EyeOutlined />
    },
    {
        key: '2.4',
        title: 'Decoder Viewer',
        path: "/viewerdecoder",
        exact: true,
        parent: key_viewer,
        icon: <EyeOutlined />
    },
    {
        key: '2.5',
        title: 'GMCH Viewer',
        path: "/viewergmch",
        exact: true,
        parent: key_viewer,
        icon: <EyeOutlined />
    },
    {
        key: '2.6',
        title: 'Group Viewer',
        path: "/viewerbygroup",
        exact: true,
        parent: key_viewer,
        icon: <EyeOutlined />
    },
    {
        key: '2.7',
        title: 'Esports(Png) Viewer',
        path: "/viewerpng",
        exact: true,
        parent: key_viewer,
        icon: <EyeOutlined />
    },
    {
        key: '2.8',
        title: "G88 ESports",
        path: "/viewerg88",
        exact: true,
        parent: key_viewer,
        icon: <DribbbleOutlined />
    },
    //#endregion viewer

    //#region monitor --key =key_monitor

    //#endregion monitor

    //#region Online --key =key_online
    {
        key: '4-1',
        title: 'User Online',
        path: "/online",
        exact: true,
        parent: key_online,
        icon: <UserOutlined />
    },
    {
        key: '4-2',
        title: 'System Health',
        path: "/systemHealth",
        exact: true,
        parent: key_online,
        icon: <HeartOutlined />
    },
    {
        key: '4-3',
        title: 'Country',
        path: "/country",
        exact: true,
        parent: key_online,
        icon: <GlobalOutlined />
    },
    {
        key: '4-4',
        title: 'Channel',
        path: "/onlineByShow",
        exact: true,
        parent: key_online,
        icon: <PlayCircleOutlined />
    },
    //#endregion Online

    //#region Timeline --key =key_timeline

    //#endregion Timeline

    //#region Schedule --key =key_schedule

    //#endregion Schedule

    //#region Official Schedule --key =key_officialschedule
    {
        key: '7-1',
        title: 'Official Schedule',
        path: "/rbschedule",
        exact: true,
        parent: key_officialschedule,
        icon: <TableOutlined />
    },
    {
        key: '7-2',
        title: 'Incoming Schedule',
        path: "/incomingSchedule",
        exact: true,
        parent: key_officialschedule,
        icon: <TableOutlined />
    },
    //#endregion Official Schedule

    //#region management --key =key_mgmt
    {
        key: 'usrprof',
        title: 'User',
        path: "/userprofile",
        exact: true,
        parent:key_mgmt,
        icon: <UserOutlined />
    },
    {
        key: 'from DB',
        title: 'Permission',
        path: "/permission",
        exact: true,
        parent:key_mgmt,
        icon: <FileProtectOutlined />
    },
    //#endregion management

    //#region sample --key =
    {
        key: 'from DB',
        title: 'sample val',
        path: "/samplepath",
        exact: true,
        parent: "taken from --key",
        icon: <TableOutlined />
    },
    //#endregion sample
]
export const channelSettingsMenu = [
    {
        key: '1-1',
        title: 'Channel Setting',
        path: "/channel",
        parent: 1,
        exact: true,
        icon: <SettingOutlined />
    }
];

export const viewerMenu = [
    {
        key: '2-1',
        title: 'Basic Viewer',
        path: "/viewer",
        parent: 2,
        exact: true,
        icon: <EyeOutlined />
    },
    {
        key: '2.2',
        title: 'Horse RTMP Viewer',
        path: "/viewerhr",
        exact: true,
        parent: 2,
        icon: <EyeOutlined />
    },
    {
        key: '2.3',
        title: 'Horse H5 Viewer',
        path: "/viewerhrh5",
        exact: true,
        parent: 2,
        icon: <EyeOutlined />
    },
    {
        key: '2.4',
        title: 'Decoder Viewer',
        path: "/viewerdecoder",
        exact: true,
        parent: 2,
        icon: <EyeOutlined />
    },
    {
        key: '2.5',
        title: 'GMCH Viewer',
        path: "/viewergmch",
        exact: true,
        parent: 2,
        icon: <EyeOutlined />
    },
    {
        key: '2.6',
        title: 'Group Viewer',
        path: "/viewerbygroup",
        exact: true,
        parent: 2,
        icon: <EyeOutlined />
    },
    {
        key: '2.7',
        title: 'Esports(Png) Viewer',
        path: "/viewerpng",
        exact: true,
        parent: 2,
        icon: <EyeOutlined />
    },
    {
        key: '2.8',
        title: "G88 ESports",
        path: "/viewerg88",
        exact: true,
        parent: 2,
        icon: <DribbbleOutlined />
    },
];

export const onlineMenu = [
    {
        key: '4-1',
        title: 'User Online',
        path: "/online",
        exact: true,
        parent: 4,
        icon: <UserOutlined />
    },
    {
        key: '4-2',
        title: 'System Health',
        path: "/systemHealth",
        exact: true,
        parent: 4,
        icon: <HeartOutlined />
    },
    {
        key: '4-3',
        title: 'Country',
        path: "/country",
        exact: true,
        parent: 4,
        icon: <GlobalOutlined />
    },
    {
        key: '4-4',
        title: 'Channel',
        path: "/onlineByShow",
        exact: true,
        parent: 4,
        icon: <PlayCircleOutlined />
    },
]

export const scheduleListMenu = [
    {
        key: '7-1',
        title: 'Official Schedule',
        path: "/rbschedule",
        exact: true,
        parent: 7,
        icon: <TableOutlined />
    },
    {
        key: '7-2',
        title: 'Incoming Schedule',
        path: "/incomingSchedule",
        exact: true,
        parent: 7,
        icon: <TableOutlined />
    },
]

